import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, CardBody, CardHeader } from 'reactstrap';
import randomColor from 'randomcolor';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';

const ProductQuantityChart = ({ opportunityData }) => {
  if (!Chart.plugins.getAll().find((p) => p.id === 'datalabels')) {
    Chart.register(ChartDataLabels);
  }

  const prepareQuantityChartData = () => {
    if (!opportunityData?.length) return { labels: [], datasets: [] };

    const allProductNames = new Set();
    opportunityData.forEach((opportunity) => {
      opportunity.products.forEach((product) => {
        allProductNames.add(product.productName);
      });
    });

    const sortedOpportunities = [...opportunityData].sort(
      (a, b) => a.id - b.id
    );
    const labels = sortedOpportunities.map((opportunity) => opportunity.name);

    const datasets = Array.from(allProductNames).map((productName) => {
      const data = sortedOpportunities.map((opportunity) => {
        const product = opportunity.products.find(
          (p) => p.productName === productName
        );
        return product ? product.quantity : 0;
      });

      const formattedData = data.map((value) => ({
        y: value
      }));

      return {
        label: productName,
        data: formattedData,
        backgroundColor: randomColor({ luminosity: 'light', hue: 'random' })
      };
    });

    return { labels, datasets };
  };

  const quantityChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30
      }
    },
    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: 'Quantidade por Produto'
      },
      datalabels: {
        display: function (context) {
          return context.dataset.data[context.dataIndex].y > 0;
        },
        color: '#000',
        anchor: 'end',
        align: 'top',
        offset: 0,
        font: {
          size: 10
        },
        formatter: function (value) {
          return ` ${value.y}`;
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Fase da Oportunidade'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Quantidade'
        }
      }
    }
  };

  return (
    <Card>
      <CardHeader>
        <h6 className="surtitle">Visão Geral</h6>
        <h5 className="h3 mb-0">
          Quantidade de Produtos por Fase da Oportunidade
        </h5>
      </CardHeader>
      <CardBody>
        <div style={{ height: '450px' }}>
          <Bar
            data={prepareQuantityChartData()}
            options={quantityChartOptions}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default ProductQuantityChart;
